import moment from "moment";
const currentDate = moment().format("DD-MM-YYYY");

export default {
    address: "",
    assigned_manager: "",
    assigned_operatives: [],
    assigned_supervisor: "",
    client_name: "",
    attached_files: [],
    description_of_works: "",
    end_date: currentDate,
    job_id: "",
    job_name: "",
    job_type: "",
    jobpack_type: "",
    location_lat: "53.35046029646121",
    location_long: "-6.2605484635565745",
    start_date: currentDate,
    job_vehicles: [],
    job_equipments: [],
    status: "active",
    calendar_color: "",
    sswp_config_uid: "",
    contract_no: "",
    quote_no: "",

    client_contact_no: "",
    job_stage: ["Pre-Works", "Works", "Aftercare", "Complete"],
    departments: null,
    areas: null,
    qr_code_url: "",
};
